import dialogType from '../../../display/dialogs/dialogType'

import api from '../../../configs/api'

const prohibitions =
{
    title : 'Interdictions' ,
    edit  :
    {
        agree       : 'Enregistrer' ,
        description : 'Sélectionner des interdictions dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Interdictions' ,
        uri         : api.thesaurus.places_regulations,
        type        : dialogType.THESAURUS_CHECKER
    },
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default prohibitions ;